/* ============================================================
   BELANTTI — ENGO CORE PLUGINS (Step 9)
   Purpose:
   - Preserve the jQuery cookie API used by legacy EnGo scripts
   - Preserve ENGO countdown behaviour
   - Replace the oversized legacy History.js/browser polyfills with
     a minimal native History API compatibility layer
   - No storefront content, SEO metadata, schema or tracking changes
============================================================ */

(function ($, document) {
  'use strict';

  var pluses = /\+/g;

  function raw(value) {
    return value;
  }

  function decoded(value) {
    return decodeURIComponent(String(value).replace(pluses, ' '));
  }

  var config = $.cookie = function (key, value, options) {
    if (value !== undefined) {
      options = $.extend({}, config.defaults, options);

      if (value === null) options.expires = -1;

      if (typeof options.expires === 'number') {
        var days = options.expires;
        var expires = options.expires = new Date();
        expires.setDate(expires.getDate() + days);
      }

      value = config.json ? JSON.stringify(value) : String(value);

      return (document.cookie = [
        encodeURIComponent(key), '=', config.raw ? value : encodeURIComponent(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '',
        options.path ? '; path=' + options.path : '',
        options.domain ? '; domain=' + options.domain : '',
        options.secure ? '; secure' : ''
      ].join(''));
    }

    var decode = config.raw ? raw : decoded;
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < cookies.length; i += 1) {
      var parts = cookies[i].split('=');
      if (decode(parts.shift()) === key) {
        var cookie = decode(parts.join('='));
        return config.json ? JSON.parse(cookie) : cookie;
      }
    }

    return null;
  };

  config.defaults = {};

  $.removeCookie = function (key, options) {
    if ($.cookie(key) !== null) {
      $.cookie(key, null, options);
      return true;
    }
    return false;
  };
})(jQuery, document);

(function ($) {
  'use strict';

  $.fn.ENGO_CountDown = function (options) {
    return this.each(function () {
      new $.ENGO_CountDown(this, options);
    });
  };

  $.ENGO_CountDown = function (element, options) {
    this.options = $.extend({
      autoStart: true,
      LeadingZero: true,
      DisplayFormat: '<div><span>%%D%%</span> Days</div><div><span>%%H%%</span> Hours</div><div><span>%%M%%</span> Mins</div><div><span>%%S%%</span> Secs</div>',
      FinishMessage: 'Expired',
      CountActive: true,
      TargetDate: null
    }, options || {});

    if (!this.options.TargetDate) return;

    this.timer = null;
    this.element = element;
    this.CountStepper = -1;
    this.SetTimeOutPeriod = 990;

    var then = new Date(this.options.TargetDate);
    var now = new Date();
    var diff = this.CountStepper > 0 ? new Date(now - then) : new Date(then - now);
    var seconds = Math.floor(diff.valueOf() / 1000);

    this.CountBack(seconds, this);
  };

  $.ENGO_CountDown.prototype.calculateDate = function (seconds, divisor, modulo) {
    var value = ((Math.floor(seconds / divisor)) % modulo).toString();
    if (this.options.LeadingZero && value.length < 2) value = '0' + value;
    return '<b>' + value + '</b>';
  };

  $.ENGO_CountDown.prototype.CountBack = function (seconds, self) {
    if (seconds < 0) {
      self.element.innerHTML = '<div class="labelexpired"> ' + self.options.FinishMessage + '</div>';
      return;
    }

    clearTimeout(self.timer);

    var display = self.options.DisplayFormat
      .replace(/%%D%%/g, self.calculateDate(seconds, 86400, 100000))
      .replace(/%%H%%/g, self.calculateDate(seconds, 3600, 24))
      .replace(/%%M%%/g, self.calculateDate(seconds, 60, 60))
      .replace(/%%S%%/g, self.calculateDate(seconds, 1, 60));

    self.element.innerHTML = display;

    if (self.options.CountActive) {
      self.timer = setTimeout(function () {
        self.CountBack(seconds + self.CountStepper, self);
      }, self.SetTimeOutPeriod);
    }
  };

  function targetDate($element) {
    var rawDate = $element.data('date');
    if (!rawDate) return null;
    var parts = String(rawDate).split('-');
    if (parts.length < 6) return null;
    return parts[0] + '/' + parts[1] + '/' + parts[2] + ' ' + parts[3] + ':' + parts[4] + ':' + parts[5];
  }

  function initialise(selector, format) {
    $(selector).each(function () {
      var $this = $(this);
      var date = targetDate($this);
      if (!date) return;
      $this.ENGO_CountDown({
        TargetDate: date,
        DisplayFormat: format,
        FinishMessage: 'Expired'
      });
    });
  }

  $(function () {
    var listFormat = '<li class="list-inline-item mr-0"> <p class="mb-0">%%D%%</p> <span>day</span> </li> <li class="list-inline-item mr-0"> <p class="mb-0">%%H%%</p> <span>hours</span> </li> <li class="list-inline-item mr-0"> <p class="mb-0">%%M%%</p> <span>mins</span> </li> <li class="list-inline-item mr-0"> <p class="mb-0">%%S%%</p> <span>secs</span> </li>';
    var standardFormat = '<div class="countdown-times"><div class="day distance"><div class="number">%%D%%</div> <div class="text">days </div></div><div class="hours distance"><div class="number">%%H%%</div><div class="text"> <div class="text">hours </div></div></div><div class="minutes distance"><div class="number">%%M%%</div><div class="text"> mins</div> </div><div class="seconds distance"><div class="number">%%S%%</div> <div class="text">secs</div> </div></div>';
    var v1Format = '<li><span id="days">%%D%%</span>Days</li><li><span id="hours">%%H%%</span>Hours</li><li><span id="minutes">%%M%%</span>Mins</li><li><span id="seconds">%%S%%</span>Sec</li>';

    initialise('[data-countdown="section-countdown"]', listFormat);
    initialise('[data-countdown="section-countdown-v2"]', listFormat);
    initialise('[data-countdown="countdown"]', standardFormat);
    initialise('[data-countdown="countdown-hd-1"]', standardFormat);
    initialise('[data-countdown="countdown-hd-2"]', standardFormat);
    initialise('[data-countdown="countdown-hd-3"]', standardFormat);
    initialise('[data-countdown="countdown-v1"]', v1Format);
  });
})(jQuery);

(function (window) {
  'use strict';

  var nativeHistory = window.history;

  function emitStateChange(state) {
    var event;
    try {
      event = new PopStateEvent('popstate', { state: state });
    } catch (error) {
      event = document.createEvent('Event');
      event.initEvent('popstate', true, true);
      event.state = state;
    }
    window.dispatchEvent(event);
  }

  var History = window.History = window.History || {};

  History.enabled = !!(nativeHistory && nativeHistory.pushState);

  History.Adapter = History.Adapter || {
    bind: function (element, eventName, callback) {
      if (eventName === 'statechange') {
        element.addEventListener('popstate', callback, false);
      } else {
        element.addEventListener(eventName, callback, false);
      }
    },
    trigger: function (element, eventName) {
      if (eventName === 'statechange') {
        emitStateChange(nativeHistory.state);
        return;
      }
      var event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
      element.dispatchEvent(event);
    },
    extractEventData: function (key, event, extra) {
      return (event && event[key]) || (extra && extra[key]);
    },
    onDomLoad: function (callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }
  };

  History.getState = function () {
    return {
      data: nativeHistory.state || {},
      title: document.title,
      url: window.location.href
    };
  };

  History.pushState = function (data, title, url) {
    nativeHistory.pushState(data, title || '', url);
    emitStateChange(data);
    return true;
  };

  History.replaceState = function (data, title, url) {
    nativeHistory.replaceState(data, title || '', url);
    emitStateChange(data);
    return true;
  };

  History.back = function () { nativeHistory.back(); };
  History.forward = function () { nativeHistory.forward(); };
  History.go = function (delta) { nativeHistory.go(delta); };
})(window);
